/* Rosebound per-page filter settings (Oct 29, 2026). Loads after rb-filter-map.js and before
   rb-filter-preview.js, and adjusts window.RB_FILTERS for merch pages:
   1) product types added since the Oct 10 merch map (apply on every merch page, e.g. Gifts & Bookish Goods);
   2) the Character group (cast: tags), shown only on the pages listed in CAST_PAGES;
   3) page-specific setups in PAGES (which groups show, which open, a page-specific Type list, sort label).
   To give another page its own setup, add its collection handle to PAGES (and to the section's
   "Merch collections" setting so it gets merch filters). */
(function () {
  var F = window.RB_FILTERS, root = document.querySelector('[data-rbf-root]');
  if (!F || !root || !F.merch) return;
  var handle = root.dataset.collection;

  /* 1) new product types -> existing Type options (Gifts & Bookish Goods and every merch page) */
  var ADD_TYPES = {
    'Candles & Home': ['Fragrance'],
    'Mugs & Drinkware': ['Drinking Glass'],
    'Journals & Stationery': ['Stationery'],
    'Crafts, Puzzles & Games': ['Plush']
  };
  var HOME = { v: 'Home & Décor', type: ['Map', 'Pennant', 'Sign', 'Desk Mat', 'Art Print', 'Illustrations', 'Ornament'] };

  /* 2) Character group: cast:<name> tags */
  var CAST = { key: 'cast', label: 'Character', field: 'cast', values: [
    { v: 'Feyre', tag: ['cast:feyre'] },
    { v: 'Rhysand', tag: ['cast:rhysand'] },
    { v: 'Nesta', tag: ['cast:nesta'] },
    { v: 'Cassian', tag: ['cast:cassian'] },
    { v: 'Azriel', tag: ['cast:azriel'] },
    { v: 'Elain', tag: ['cast:elain'] },
    { v: 'The Suriel', tag: ['cast:suriel'] }
  ]};
  var CAST_PAGES = ['acotar'];

  /* 3) page setups. type: a shorter Type list for this page (10 or fewer, so the sidebar shows them all,
     in this order). hide: groups that don't help on this page. open: groups open by default. */
  var PAGES = {
    acotar: {
      type: [
        { v: 'Jewelry', type: ['Jewelry'] },
        { v: 'Candles & Fragrance', type: ['Candle', 'Fragrance'] },
        { v: 'Mugs & Drinkware', type: ['Mug', 'Drinking Glass'] },
        { v: 'Apparel & Hats', type: ['Apparel', 'Hat'] },
        { v: 'Bookmarks', type: ['Bookmark'] },
        { v: 'Pins & Bag Charms', type: ['Pin', 'Bag Charm', 'Keychain'] },
        { v: 'Stickers', type: ['Sticker'] },
        { v: 'Stationery & Pouches', type: ['Journal', 'Notes', 'Planner', 'Calendar', 'Stationery', 'Zipper Pouch', 'Book Cover'] },
        { v: 'Home, Games & More', type: ['Map', 'Pennant', 'Sign', 'Desk Mat', 'Art Print', 'Illustrations', 'Ornament', 'Plush', 'Puzzle', 'Game', 'Tea', 'Coloring Book'] },
        { v: 'Books', type: ['Book'] }
      ],
      hide: ['fandom', 'reads', 'vibe', 'occasion'],
      open: ['type', 'cast', 'price'],
      sortLabel: 'Featured'
    }
  };

  var page = PAGES[handle] || {};
  var groups = F.groups.map(function (g) {
    if (g.key !== 'type') return g;
    if (page.type) return { key: g.key, label: g.label, field: g.field, values: page.type };
    var values = g.values.map(function (v) {
      var add = ADD_TYPES[v.v]; if (!add) return v;
      var c = {}; for (var k in v) c[k] = v[k];
      c.type = (v.type || []).concat(add);
      return c;
    });
    var at = -1; values.forEach(function (v, i) { if (v.v === 'Crafts, Puzzles & Games') at = i; });
    values.splice(at < 0 ? values.length : at, 0, HOME);
    return { key: g.key, label: g.label, field: g.field, values: values };
  });
  if (CAST_PAGES.indexOf(handle) > -1) {
    var ti = 0; groups.forEach(function (g, i) { if (g.key === 'type') ti = i; });
    groups.splice(ti + 1, 0, CAST);
  }
  if (page.hide) groups = groups.filter(function (g) { return page.hide.indexOf(g.key) < 0; });
  F.groups = groups;
  if (page.open) F.open = page.open;
  if (page.sortLabel) {
    var s = root.querySelector('[data-rbf-sort]');
    if (s && s.options[0]) s.options[0].textContent = page.sortLabel;
  }
})();
